import 'bootstrap/dist/css/bootstrap.min.css';
import { mainstore } from "../../store";


const FooterComponent = () => {
    return (
        <footer className="page-footer font-small fixed-bottom" style={{height:'35px'}}>
            <div className="footer-copyright text-center page-footer-copyright user-select-none"><a href="/" className="page-footer-link text-decoration-none">© 2024 IT Curves</a> - Version {mainstore.getState().configuration.CurrentApplicationVersion}</div>
        </footer>
    );
};

export default FooterComponent;